module.exports = __webpack_public_path__ + "static/media/ground.ff3b88df.svg";